import { useState, useCallback, useEffect, useRef } from "react";
import { useHttpClient } from "shared/hooks/http-hook";

/**
 * Admin istatistik endpointleri için ortak veri çekme hook'u.
 * path: "/admin/statistics/..." ile başlayan yol
 * autoLoad: true ise mount olduğunda otomatik yükler
 */
export const useStatsFetch = (path, autoLoad = true) => {
  const { sendRequest } = useHttpClient();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const loadedPathRef = useRef(null);

  const load = useCallback(
    async (overridePath) => {
      const targetPath = overridePath || path;
      setIsLoading(true);
      setError(null);
      try {
        const responseData = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}${targetPath}`);
        setData(responseData);
        loadedPathRef.current = targetPath;
        return responseData;
      } catch (err) {
        setError(err?.message || "Veri alınamadı.");
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    [sendRequest, path]
  );

  // İlk yükleme + path değiştiğinde (örn. gün filtresi) yeniden yükleme
  useEffect(() => {
    if (autoLoad && loadedPathRef.current !== path) {
      load();
    }
  }, [autoLoad, path, load]);

  return { data, isLoading, error, load, hasLoaded: loadedPathRef.current !== null };
};
